import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-m-3" }
const _hoisted_2 = { class: "p-field p-mb-3" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-mb-3" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = { class: "p-col" }
const _hoisted_11 = { class: "table-header" }
const _hoisted_12 = { class: "p-input-icon-left" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_KnInputFile = _resolveComponent("KnInputFile")
  const _component_Card = _resolveComponent("Card")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "p-mb-3" }, {
      content: _withCtx(() => [
        _createVNode("form", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("span", _hoisted_3, [
              _createVNode(_component_InputText, {
                id: "name",
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.schema.name.$invalid && _ctx.v$.schema.name.$dirty
                            }],
                type: "text",
                modelValue: _ctx.v$.schema.name.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.schema.name.$model = $event)),
                modelModifiers: { trim: true },
                maxLength: "100",
                onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.schema.name.$touch())),
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onFieldChange('name', $event.target.value))),
                "data-test": "name-input"
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              vComp: _ctx.v$.schema.name,
              additionalTranslateParams: { fieldName: _ctx.$t('common.name') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_InputText, {
                id: "description",
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.schema.description.$invalid && _ctx.v$.schema.description.$dirty
                            }],
                type: "text",
                modelValue: _ctx.v$.schema.description.$model,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.schema.description.$model = $event)),
                modelModifiers: { trim: true },
                maxLength: "500",
                onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.schema.description.$touch())),
                onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onFieldChange('description', $event.target.value))),
                "data-test": "description-input"
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('common.description')), 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              vComp: _ctx.v$.schema.description,
              additionalTranslateParams: { fieldName: _ctx.$t('common.description') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("span", _hoisted_9, [
              _createVNode(_component_KnInputFile, {
                label: "",
                changeFunction: _ctx.onVersionUpload,
                accept: ".xml,.csv",
                visibility: true
              }, null, 8, ["changeFunction"])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Card, null, {
      header: _withCtx(() => [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.mondrianSchemasManagement.detail.savedVersions')), 1)
          ]),
          _: 1
        })
      ]),
      content: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar"
            }))
          : _createCommentVNode("", true),
        _createVNode("div", null, [
          _createVNode("div", _hoisted_10, [
            (!_ctx.loading)
              ? (_openBlock(), _createBlock(_component_DataTable, {
                  key: 0,
                  value: _ctx.versions,
                  scrollable: true,
                  scrollHeight: "40vh",
                  loading: _ctx.loading,
                  rows: 7,
                  class: "p-datatable-sm kn-table",
                  dataKey: "id",
                  responsiveLayout: "stack",
                  breakpoint: "960px",
                  selection: _ctx.selectedVersion,
                  "onUpdate:selection": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedVersion = $event)),
                  filters: _ctx.filters,
                  "onUpdate:filters": _cache[9] || (_cache[9] = ($event: any) => (_ctx.filters = $event)),
                  onRowSelect: _ctx.onActiveVersionChange
                }, {
                  header: _withCtx(() => [
                    _createVNode("div", _hoisted_11, [
                      _createVNode("span", _hoisted_12, [
                        _hoisted_13,
                        _createVNode(_component_InputText, {
                          class: "kn-material-input",
                          modelValue: _ctx.filters['global'].value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filters['global'].value = $event)),
                          type: "text",
                          placeholder: _ctx.$t('common.search'),
                          badge: "0"
                        }, null, 8, ["modelValue", "placeholder"])
                      ])
                    ])
                  ]),
                  empty: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
                  ]),
                  filter: _withCtx(({ filterModel }) => [
                    _createVNode(_component_InputText, {
                      type: "text",
                      modelValue: filterModel.value,
                      "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
                      class: "p-column-filter"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      selectionMode: "single",
                      header: _ctx.$t('managers.mondrianSchemasManagement.headers.active'),
                      headerStyle: "width: 3em"
                    }, null, 8, ["header"]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                      return (_openBlock(), _createBlock(_component_Column, {
                        field: col.field,
                        header: _ctx.$t(col.header),
                        key: col.field,
                        sortable: true,
                        style: _ctx.detailDescriptor.table.column.style
                      }, null, 8, ["field", "header", "style"]))
                    }), 128)),
                    _createVNode(_component_Column, {
                      field: "creationDate",
                      header: _ctx.$t('managers.mondrianSchemasManagement.headers.creationDate'),
                      dataType: "date"
                    }, {
                      body: _withCtx(({data}) => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(data.creationDate)), 1)
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_component_Column, {
                      style: _ctx.detailDescriptor.table.iconColumn.style,
                      onRowClick: false
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_Button, {
                          icon: "pi pi-download",
                          class: "p-button-link",
                          onClick: ($event: any) => (_ctx.downloadVersion(slotProps.data.id))
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_Button, {
                          icon: "pi pi-trash",
                          class: "p-button-link",
                          onClick: ($event: any) => (_ctx.showDeleteDialog(slotProps.data.id))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["style"])
                  ]),
                  _: 1
                }, 8, ["value", "loading", "selection", "filters", "onRowSelect"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}